import { TenantTheme } from '../tenants/unbrace';

const profileTheme = (theme: TenantTheme) => ({
  primaryColor: theme.palette.neutral.shade8,
  secondaryColor: theme.palette.neutral.shade1,
});

export default profileTheme;
